import ProductPage from "../../components/ProductPage";
import { healthInsuranceData } from "../../data/productsData";
export default function HealthInsurance() { return <ProductPage data={healthInsuranceData} />; }